import { Loader2 } from "lucide-react"
import { Thread } from "../../../../types"
import ConversationsListItem from "../../conversations-list-item"
import { ConversationsListSkeleton } from "../../skeletons"

interface Props {
  isLoading: boolean
  filteredThreads: Thread[]
  hasMore: boolean
  loadMore: () => void
  isLoadingMore: boolean
}

const List = ({
  isLoading,
  filteredThreads,
  hasMore,
  loadMore,
  isLoadingMore
}: Props) => {
  return isLoading ? (
    <ConversationsListSkeleton />
  ) : (
    <div className="overflow-hidden">
      <ul className="divide-y divide-neutral-200 overflow-y-auto">
        {filteredThreads && filteredThreads.length > 0 ? (
          filteredThreads.map(thread => (
            <ConversationsListItem thread={thread} key={thread._id} />
          ))
        ) : (
          <li className="flex justify-center py-4">
            No threads found, please try another term.
          </li>
        )}
      </ul>
      {hasMore && (
        <div className="flex justify-center py-4 border-t border-neutral-200">
          <button
            onClick={loadMore}
            disabled={isLoadingMore}
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-primary-700 bg-primary-50 border border-primary-300 rounded-lg hover:bg-primary-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
          >
            {isLoadingMore ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Loading...
              </>
            ) : (
              "Load More"
            )}
          </button>
        </div>
      )}
    </div>
  )
}

export default List
